import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useWindowDimensions } from 'hooks/useWindowDimensions';
import { Grid2 } from '@mui/material';
import { MedicalHeader } from 'components/MedicalHeader';
import { MedicalSideBar } from 'views/Medical/MedicalSideBar';
import MedicalViewProvider, { useMedicalView } from 'utils/MedicalViewProvider';
import { AppointmentType } from 'hooks/useAppointments';
import { useAuth } from 'utils/AuthProvider';
import { Role } from 'model/account';
import accountStore from '~/store/accountStore';
import medicalCareStore from '~/store/medicalCareStore';

const MedicalViewContent = () => {
  const { role, user } = useAuth();

  useEffect(() => {
    if (
      user?.id &&
      (role === Role.DOCTOR || role === Role.PHARMACIST)
    ) {
      accountStore.setIsDoctor(role === Role.DOCTOR);
      void medicalCareStore.hydrate(user.id, role);
    }
  }, [user?.id, role]);
  const { windowDimensions, mainScreenSizeMedical } = useWindowDimensions();
  const { isLeftMenuOpen } = useMedicalView();
  const type = useMemo(
    () =>
      role === Role.DOCTOR
        ? AppointmentType.medicalcare
        : AppointmentType.medicine_delivery,
    [role],
  );
  return (
    <Grid2
      container
      flexDirection={'column'}
      sx={{
        width: windowDimensions.width,
        height: windowDimensions.height,
      }}
      columns={12}
      rowGap={0}
      wrap="nowrap"
    >
      <MedicalHeader type={type} />
      <Grid2
        display={'flex'}
        flexDirection={'row'}
        flexWrap={'nowrap'}
        className="fullHeight overFlowHidden"
        sx={{ width: mainScreenSizeMedical.width }}
      >
        {isLeftMenuOpen && <MedicalSideBar />}
        <Outlet />
      </Grid2>
    </Grid2>
  );
};

export const MedicalViewContainer = () => {
  return (
    <MedicalViewProvider>
      <MedicalViewContent />
    </MedicalViewProvider>
  );
};
